import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";

import { UserContext } from "@/components/User";
import { router } from "@/views/router";

import { Footer, LoginOnBehalfBanner } from "./components";
import { NavigationBar } from "./components/Navigation/NavigationBar";

import "./_layout.scss";

interface ILayoutProps {
  topbar?: boolean;
  showNavigation?: boolean;
  footer?: boolean;
}

export const Layout: FC<ILayoutProps> = props => {
  const { children, footer, topbar, showNavigation } = props;
  const { sessionUser } = useContext(UserContext);
  const { ready } = useTranslation(["common", "public", "session", "codelists"]);

  const rootClass = "layout";

  return (
    <div className={rootClass}>
      {sessionUser.loginOnBehalfRequester && (
        <LoginOnBehalfBanner firstName={sessionUser.firstName} lastName={sessionUser.lastName} />
      )}

      {ready && topbar && (
        <Switch>
          <Route path={router.get("job-requests.detail").path}>
            <NavigationBar showNavigation={showNavigation} />
          </Route>
          <Route>
            <div className={`${rootClass}__topbar-wrapper`}>
              <NavigationBar showNavigation={showNavigation} />
            </div>
          </Route>
        </Switch>
      )}

      <div className={`${rootClass}__content-wrapper`}>{ready && children}</div>

      {ready && footer && (
        <Switch>
          <Route path={router.get("notifications").path} />
          <Route path={router.get("message-center").path} />
          <Route>
            <div className={`${rootClass}__footer-wrapper`}>
              <Footer />
            </div>
          </Route>
        </Switch>
      )}
    </div>
  );
};
